export default "__VITE_ASSET__DwVpJ95p__"